import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'

const MAINTENANCE_NOTICE_KEY = 'maintenance-notice'

/**
 * Chave do dia atual no formato `YYYY-MM-DD` (data local), usada para
 * controlar a exibição única por dia do aviso de manutenção.
 */
const getTodayKey = (): string => {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * Indica se o aviso de manutenção já foi exibido hoje neste dispositivo.
 */
export const wasMaintenanceNoticeShownToday = (): boolean => {
  const stored = makeLocalStorageAdapter().get(MAINTENANCE_NOTICE_KEY)
  return stored?.lastShownDate === getTodayKey()
}

/**
 * Registra que o aviso de manutenção foi exibido hoje, evitando novas
 * exibições no mesmo dia.
 */
export const setMaintenanceNoticeShownToday = (): void => {
  makeLocalStorageAdapter().set(MAINTENANCE_NOTICE_KEY, {
    lastShownDate: getTodayKey()
  })
}
